import { mapMutations, mapState } from 'vuex';
import { forIn } from 'lodash';

export default {
  computed: {
    ...mapState(['notifications']),

    flashMessage() {
      return this.notifications.flash;
    },
  },

  methods: {
    ...mapMutations(['clearFlash']),
  },

  watch: {
    flashMessage(value) {
      if (value) {
        const showNotification = ({ body, type = 'success' }) => {
          this.$snotify.create({
            body,
            config: {
              type,
            },
          });
        };

        if (typeof value.message === 'object') {
          forIn(value.message, (message) => {
            if (Array.isArray(message)) {
              message.forEach(body => showNotification({ body, type: value.type }));
            } else {
              showNotification({ body: message, type: value.type });
            }
          });
        } else {
          showNotification({ body: value.message, type: value.type });
        }

        this.clearFlash();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/notification-mixin.js